import { Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'eretail-modal',
  standalone: true,
  imports: [MatButtonModule, MatDialogClose],
  template: `
  @if(isCloseable()) {
    <div class="close-button-container w-100 d-flex justify-content-end">
      <button mat-icon-button mat-dialog-close>
        <i class="bi bi-x text-danger"></i>
      </button>
    </div>

  }
    <ng-content></ng-content>
  `,
  styleUrl: './eretail-modal.component.scss',
  host: {
    '[class.base-padding]': 'basePadding()'
  }
})
export class EretailModalComponent {
  
  basePadding = input(true);

  isCloseable = input(false);

}
